import { ApiInstance } from "@/libs/api-manager";
import { IAppVersionFlag } from "@/types/appVersionFlag";

export const createAppVersionFlag = async (
  payload: Pick<
    IAppVersionFlag,
    "di" | "major" | "minor" | "patch" | "clientAppId"
  >
) => {
  const { data } = await ApiInstance.post(
    "/api/vpn/app_version_flags",
    payload
  );

  return data;
};
